// extracted by mini-css-extract-plugin
export default {"icon":"EmailAttachmentsIcon_icon__+md36"};